// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1673":"334e2d74","3024":"334e2d74","4878":"62a7732f","5703":"72a4da3b","7322":"334e2d74"}[chunkId] + ".chunk.css";
};